import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { fade } from "@material-ui/core/styles/colorManipulator"
import BackgroundImage from "gatsby-background-image"
import { convertToBgImage } from "gbimage-bridge"
import { Typography, Grid } from "@material-ui/core"

const PageHeadlineStyle = theme => ({
  root: {
    "@media screen": {
      height: "300px",
    },
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  title: {
    backgroundColor: fade(theme.palette.primary.light, 0.85),
    color: "white",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
})
const useStyles = makeStyles(PageHeadlineStyle)

const getImageType = image => {
  if (typeof image === "string") {
    return "url"
  } else if ((image?.childImageSharp?.gatsbyImageData ?? false) !== false) {
    return "fluid"
  } else if ((image?.childImageSharp?.gatsbyImageData ?? false) !== false) {
    return "fixed"
  } else if ((image?.publicURL ?? false) !== false) {
    return "publicURL"
  } else {
    return "error"
  }
}

const BImage = ({ image, children, className }) => {
  const imageType = getImageType(image)
  const bgImage = convertToBgImage(image.childImageSharp?.gatsbyImageData)
  switch (imageType) {
    case "url":
      return (
        <div
          style={{
            backgroundImage: `url(${image})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {children}
        </div>
      )
    case "publicURL":
      return (
        <div
          style={{
            backgroundImage: `url(${image.publicURL})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {children}
        </div>
      )
    case "fluid":
      return <BackgroundImage {...bgImage}>{children}</BackgroundImage>
    case "fixed":
      return <BackgroundImage {...bgImage}>{children}</BackgroundImage>
    case "error":
      return <div>Bild nicht gefunden!{children}</div>
    default:
      break
  }
}
export default function PageHeadline({ headline, image }) {
  const classes = useStyles()

  return (
    <BImage image={image} className={classes.img}>
      <Grid container alignItems="flex-end" className={classes.root}>
        <Grid item>
          <Typography variant="h3" component="h1" className={classes.title}>
            {headline}
          </Typography>
        </Grid>
      </Grid>
    </BImage>
  )
}
